import React, { FunctionComponent } from 'react';

import { CommonError } from 'src/components/common-error';
import { i18n } from 'src/i18n';
import { monkeyImageProps } from 'src/resources/images';

export const PageUnderMaintenance: FunctionComponent = () => (
  <CommonError
    title={i18n.page.error.underMaintenance.title}
    subtitle={[i18n.page.error.underMaintenance.description]}
    image={monkeyImageProps}
  />
);
